// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FXl2v","wrapper":"styles_wrapper__DWzok","wrapper_checked":"styles_wrapper_checked__J5mT3","label":"styles_label__2MeKI"};